import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import Form from 'flarum/common/components/Form';
import app from 'flarum/forum/app';
import FormModal from 'flarum/common/components/FormModal';
import Button from 'flarum/common/components/Button';
import extractText from 'flarum/common/utils/extractText';
import ItemList from 'flarum/common/utils/ItemList';
import Stream from 'flarum/common/utils/Stream';
export default class RequestErasureModal extends FormModal {
  constructor() {
    super(...arguments);
    _defineProperty(this, "reason", void 0);
    _defineProperty(this, "password", void 0);
    _defineProperty(this, "user", void 0);
  }
  oninit(vnode) {
    super.oninit(vnode);
    this.reason = Stream('');
    this.password = Stream('');
    this.user = app.session.user;
  }
  className() {
    return 'RequestErasureModal Modal--small';
  }
  title() {
    return app.translator.trans('flarum-gdpr.forum.request_erasure.title');
  }
  content() {
    return m("div", {
      className: "Modal-body"
    }, m(Form, {
      className: "Form--centered"
    }, this.fields().toArray()));
  }
  fields() {
    var _this$user;
    const items = new ItemList();
    const currRequest = (_this$user = this.user) == null ? void 0 : _this$user.erasureRequest();
    if (currRequest && currRequest.status() !== 'cancelled') {
      items.add('status', m("div", {
        className: "Form-group"
      }, m("p", {
        className: "helpText"
      }, app.translator.trans("flarum-gdpr.forum.request_erasure.status.".concat(currRequest.status())))));
      if (currRequest.reason()) {
        items.add('reason', m("div", {
          className: "Form-group"
        }, m("p", {
          className: "helpText"
        }, app.translator.trans('flarum-gdpr.forum.request_erasure.reason', {
          reason: currRequest.reason()
        }))));
      }
      items.add('cancel', m("div", {
        className: "Form-group"
      }, Button.component({
        className: 'Button Button--primary Button--block',
        onclick: this.oncancel.bind(this),
        loading: this.loading
      }, app.translator.trans('flarum-gdpr.forum.request_erasure.cancel_button'))));
    } else {
      items.add('text', m("p", {
        className: "helpText"
      }, app.translator.trans('flarum-gdpr.forum.request_erasure.text')));
      if (!app.forum.attribute('passwordlessSignUp')) {
        items.add('password', m("div", {
          className: "Form-group"
        }, m("input", {
          type: "password",
          className: "FormControl",
          bidi: this.password,
          placeholder: extractText(app.translator.trans('flarum-gdpr.forum.request_erasure.password_label'))
        })));
      }
      items.add('reason', m("div", {
        className: "Form-group"
      }, m("textarea", {
        className: "FormControl",
        value: this.reason(),
        oninput: e => {
          const target = e.target;
          if (target) {
            this.reason(target.value);
          }
        },
        placeholder: extractText(app.translator.trans('flarum-gdpr.forum.request_erasure.reason_label')),
        rows: 6
      })));
      items.add('submit', m("div", {
        className: "Form-group"
      }, Button.component({
        className: 'Button Button--primary Button--block',
        type: 'submit',
        loading: this.loading
      }, app.translator.trans('flarum-gdpr.forum.request_erasure.request_button'))));
    }
    return items;
  }
  oncancel(e) {
    this.loading = true;
    m.redraw();
    if (this.user) {
      const request = this.user.erasureRequest();
      app.request({
        method: 'POST',
        url: app.forum.attribute('apiUrl') + '/user-erasure-requests/' + request.id() + '/cancel'
      }).then(() => {
        this.loading = false;
        app.modal.close();
      });
    }
  }
  data() {
    // Status is set so that the proper confirmation message is displayed.
    return {
      reason: this.reason()
    };
  }
  onsubmit(e) {
    e.preventDefault();
    this.loading = true;
    app.store.createRecord('user-erasure-requests').save(this.data(), {
      meta: {
        password: this.password()
      }
    }).then(erasureRequest => {
      if (this.user) {
        this.user.pushData({
          relationships: {
            erasureRequest
          }
        });
      }
      this.loading = false;
      m.redraw();
    }).catch(() => {
      this.loading = false;
      m.redraw();
    });
  }
}
flarum.reg.add('flarum-gdpr', 'forum/components/RequestErasureModal', RequestErasureModal);